import React from "react";
import { PageContainer } from "components/shared";
import NotificationForm from "./notificationform";
import NotificationTable from "./notificationtable";

const SendNotificationPage = () => {
  return (
    <PageContainer
      title="Send Notification"
      subtitle="Compose a push notification and review everything already sent"
    >
      <NotificationForm />
      <NotificationTable />
    </PageContainer>
  );
};

export default SendNotificationPage;
